export default "__VITE_ASSET__d268fbcd__"